<template>

  <article :class="['videosTela', filtro, destacar+'Hover', hasObra]">
    <Letreiro :title="titulo" />
    <section :class="tamanho">
      <div class="trabalho" v-for="trabalho in trabalhos">
        <router-link :to="{ name: 'home', params: {path: $route.params.path , cat: trabalho.type, obra: trabalho.id} }" @mouseenter.native="destaque(trabalho.type, trabalho.id)" @mouseleave.native="destaque()">
          <img :src="require('../assets/trabalhos/' + trabalho.img)" :alt="trabalho.name" />
        </router-link>
      </div>
    </section>

    <nav>
      <h3 id="cineNav" @click="goTo('cinema')">
        Cinema
        <p>Nossos projetos cinematográficos contam histórias que buscam maximizar a conexão com o público, explorando formatos consolidados ou as novas linguagens.</p>
      </h3>
      <h3 id="midiNav" @click="goTo('midias')">
        Novas Mídias
        <p>A revolução digital trouxe mais velocidade e conectividade ao mundo, nossos projetos em novas mídias investigam formas surpreendentes de contar histórias.</p>
      </h3>
      <h3 id="prodNav" @click="goTo('producao')">
        Produção Cultural
        <p>Além de contar histórias e desenvolver tecnologias, buscamos produzir impacto social realizando oficinas, produzindo mostras e criando materiais de difusão artística e política.</p>
      </h3>
    </nav>

    <div v-if="obra" class="conteudo">
      <div class="descricao">
        <h3>{{works[obra-1].name}}</h3>
        <div v-html="works[obra-1].texto" class="texto"></div>
      </div>
      <aside v-if="works[obra-1].link || works[obra-1].video">
        <a v-if="works[obra-1].link" :href="works[obra-1].link" target="_blank" class="link">
          ACESSE
        </a>
        <router-link class="link" v-if="works[obra-1].video" :to="{ name: 'home', params: {path: $route.params.path , cat: $route.params.cat, obra: $route.params.obra, video: works[obra-1].video} }">
          ASSISTA
        </router-link>
      </aside>
    </div>
    <div v-else class="conteudo" v-html="conteudo"></div>
    <div class="volta">
      <router-link :to="{ name: 'home', params: {path: $route.params.path} }" v-if="obra" class="scroll-left">
        <span class="arrow-left">
        <!-- css generated icon -->
        </span>
      </router-link>
    </div>
  </article>

</template>

<script>
import Letreiro from '@/components/Letreiro.vue'
import works from '@/static/projetos.js'

export default {
  name: 'VideosTela',
  components: {
    Letreiro
  },
  data() {
    return {
      works: works,
      conteudo: '',
      titulo: this.$route.params.cat == 'cinema' ? 'Cinema' :
              this.$route.params.cat == 'midias' ? 'NovasMídias' :
              this.$route.params.cat == 'producao' ? 'ProduçãoCultural' : 'Trabalhos',
      filtro: this.$route.params.cat,
      obra: this.$route.params.obra,
      vid: this.$route.params.video ? this.$route.params.video : '',

      destacar: this.$route.params.cat ? this.$route.params.cat : '',

      options: { color: 'fff', autoplay: true, title: false, byline: false, controls: true },
      playerVars: {autoplay: 1, modestbranding: 1, showinfo: 0},
    }
  },
  computed: {
      trabalhos(){
          return  this.obra ? this.works.filter(w => w.id == this.obra) :
                  this.filtro ? this.works.filter(w => w.type == this.filtro) :
                  this.works.slice(0,15);
      },
      tamanho(){
          return 'tamanho' + this.trabalhos.length;
      },
      hasObra() {
        return this.obra ? 'obra' : '';
      }
  },
  methods: {
    goTo(str) {
      let link = this.$route.params.cat == str ? { name: 'home', params: { path: 'Trabalhos'} } : { name: 'home', params: { path: 'Trabalhos', cat: str } };
      this.filtro = this.$route.params.cat == str ? undefined : this.filtro;
      this.titulo = this.$route.params.cat == str ? 'Trabalhos' : str;
      this.$router.push(link);
    },
    destaque(str, id){
      this.destacar = str ? str : '';
      if(id){
        let workId = this.works.filter(w => w.id == id);
        this.conteudo = '<h3>' + workId[0].name + '</h3>' + workId[0].texto + '<p class=mais>clique para saber mais</p>';
      } else {
        this.conteudo = '';
      }
    }
  },
  watch: {
    '$route' (to, from){
      this.obra   = this.$route.params.obra;
      this.vid    = this.$route.params.video ? this.$route.params.video : '';
      this.filtro = this.$route.params.cat;
      this.titulo = this.$route.params.cat == 'cinema' ? 'Cinema' :
                    this.$route.params.cat == 'midias' ? 'NovasMídias' :
                    this.$route.params.cat == 'producao' ? 'ProduçãoCultural' : 'Trabalhos';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.videosTela {position: relative; grid-template-columns: 50px 50vw 50px 1fr; grid-template-rows: 8vw 1fr 5vh;}
section {
  grid-column: 1 / 4; grid-row: 1 / 4;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: 3px;
  overflow: visible;
}
.trabalho {
  position: relative;
  width: 100%; height: 100%;
  background-color: #ffd300;
  mix-blend-mode: overlay;
}
.trabalho img {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  transition: all .5s ease-in-out;
  mix-blend-mode: luminosity;
  opacity: .7;
}
.trabalho:hover img {mix-blend-mode: unset; opacity: .8}


nav {display: flex; align-items: stretch; justify-content: space-between; margin-right: 2vw;}
nav h3 {font-size: 1.9vw; position: relative;}
nav h3 p {position: absolute; font-size: .6em; color: #77221b; font-weight: 100; visibility: hidden; opacity: 0; transition: opacity .5s ease-in-out}
#cineNav p, #prodNav p {width: 39vw}
#prodNav p {right: 0; text-align: right;}
#midiNav p {width: 30vw}
#cineNav:hover p, #midiNav:hover p, #prodNav:hover p {visibility: visible; opacity: 1;}
nav h3::after {content: ''; display: block; background-color: #d55349; width: 0; height: 8px; transition: all .5s ease-in-out;}
nav h3:hover:after {width: 100%}
.cinemaHover #cineNav::after, .midiasHover #midiNav::after, .producaoHover #prodNav::after {width: 100%}
.cinema #cineNav, .midias #midiNav, .producao #prodNav {color: #77221b;}
.cinema #cineNav::after, .midias #midiNav::after, .producao #prodNav::after {width: 100%; background-color: #77221b;}


.conteudo {
  text-align: left;
  margin: 5vh 2vw;
}
.conteudo >>> ul {list-style: none; padding: 0}
.conteudo >>> .mais {color: #d55349; font-size: small; padding-top: 5vh;}




/* -- Obra Selecionada -- */
.obra h1 {display: none;}
.obra .trabalho {background-color: inherit; mix-blend-mode: multiply;}
.obra .trabalho img {mix-blend-mode: unset;}
.obra .conteudo >>> .mais {display: none;}

aside {
  display: flex;
  flex-direction: column;
}
aside a { padding-top: 5vh; position: relative; align-self: flex-start;}
aside a::after {content: ''; display: block; background-color: #77221b; width: 0; height: 8px; transition: all .5s ease-in-out;}
aside a:hover:after {width: 100%;}

/* -- SETA -- */
.volta {position: relative;}
.scroll-left {
  position: absolute;
  right: 2vw;
  width: 5vw;
  height: 30px;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
}
.arrow-left {
  display: block;
  margin: 0;
}
.arrow-left::before {
  content: '';
  display: block;
  margin: auto;
  padding: 0;
  width: 5px;
  height: 5px;
  border-top: 2px solid #d55349;
  border-right: 2px solid #d55349;
  transform: rotate(225deg);
}
.arrow-left::after{
  content: 'voltar';
  position: absolute;
  font-size: x-small;
  right: 0;
}
.scroll-left::after {
  animation: elasticus 2s cubic-bezier(1, 0, 0, 1) reverse infinite;
  display: block;
  margin-left: -5px;
  height: 2px;
  width: 5vw;
  background: #d55349;
  content: ' ';
}
.scroll-left:hover .arrow-left::before, .scroll-left:hover .arrow-left::after {border-color: #77221b; color: #77221b;}
.scroll-left:hover:after {background: #77221b}

/* SETA */
@keyframes elasticus {
  0% {
    transform-origin: 0% 0%;
    transform: scale(0, 1);
  }
  50% {
    transform-origin: 0% 0%;
    transform: scale(1, 1);
  }
  50.1% {
    transform-origin: 100% 0%;
    transform: scale(1, 1);
  }
  100% {
    transform-origin: 100% 0%;
    transform: scale(0, 1);
  }
}


/* -- PADROES -- */
.tamanho1, .tamanho2 { grid-template-columns: 1fr }
.tamanho3, .tamanho4 { grid-template-columns: repeat(2, 1fr)}
.tamanho5, .tamanho7, .tamanho9 { grid-template-columns: repeat(3, 1fr)}
.tamanho6, .tamanho8, .tamanho15  {grid-template-columns: repeat(5, 1fr)}
.tamanho10, .tamanho11 {grid-template-columns: repeat(4, 1fr)}
.tamanho3 .trabalho,
.tamanho5 .trabalho,
.tamanho7 .trabalho,
.tamanho9 .trabalho:nth-child(2n), .tamanho9 .trabalho:nth-child(5),
.tamanho10 .trabalho,
.tamanho11 .trabalho:nth-child(3n), .tamanho11 .trabalho:nth-child(3n+2),
.tamanho12 .trabalho,
.tamanho14 .trabalho:nth-child(7n+2), .tamanho14 .trabalho:nth-child(7n+4), .tamanho14 .trabalho:nth-child(7n+5), .tamanho14 .trabalho:nth-child(7n+6),
.tamanho15 .trabalho:nth-child(2), .tamanho15 .trabalho:nth-child(4), .tamanho15 .trabalho:nth-child(5), .tamanho15 .trabalho:nth-child(8), .tamanho15 .trabalho:nth-child(9), .tamanho15 .trabalho:nth-child(11), .tamanho15 .trabalho:nth-child(13)
{ grid-area: span 2 / span 1; }

.tamanho3 .trabalho:nth-child(3),
.tamanho8 .trabalho,
.tamanho9 .trabalho:nth-child(1), .tamanho9 .trabalho:nth-child(8),
.tamanho10 .trabalho:nth-child(3n), .tamanho10 .trabalho:nth-child(10n),
.tamanho11 .trabalho:nth-child(1), .tamanho11 .trabalho:nth-child(n+9),
.tamanho12 .trabalho:nth-child(3n),
.tamanho13 .trabalho:nth-child(4n+1),
.tamanho14 .trabalho:nth-child(1), .tamanho14 .trabalho:nth-child(10),
.tamanho15 .trabalho
{ grid-area: span 1 / span 2; }

.tamanho4 .trabalho:nth-child(1), .tamanho4 .trabalho:nth-child(2)
{ grid-area: span 3 / span 1; }

.tamanho5 .trabalho:nth-child(5n+1), .tamanho5 .trabalho:nth-child(5n),
.tamanho6 .trabalho,
.tamanho8 .trabalho:nth-child(4n), .tamanho8 .trabalho:nth-child(4n+1)
{ grid-area: span 1 / span 3; }

.tamanho4 .trabalho,
.tamanho6 .trabalho:nth-child(4n+1),
.tamanho7 .trabalho:nth-child(6n+1)
{ grid-area: span 2 / span 2; }

.tamanho11 .trabalho:nth-child(10), .tamanho11 .trabalho:nth-child(11),
.tamanho13 .trabalho:nth-child(9)
{ grid-area: span 1 / span 1; }



/* --- LETREIRO --- */
.triggerTrabalhos h1 >>> span {
  animation-name: letreiro;
  animation-duration: 1s;
  animation-direction: reverse;
  animation-fill-mode: both;
  opacity: 0;
}
  /* TRABALHOS */
   h1 >>> span:nth-child(4) { /* b */
    grid-column: 4;
    grid-row: 3;
    animation-delay: 0.5s;
   }
   h1 >>> span:nth-child(5) { /* a */
    grid-column: 8;
    grid-row: 5;
    animation-delay: 0.4s;
   }
   h1 >>> span:nth-child(6) { /* l */
    grid-column: 2;
    grid-row: 6;
    animation-delay: 0.3s;
   }
   h1 >>> span:nth-child(7) { /* h */
    grid-column: 4;
    grid-row: 7;
    animation-delay: 0.2s;
   }
   h1 >>> span:nth-child(8) { /* o */
    grid-column: 6;
    grid-row: 8;
    animation-delay: 0.1s;
   }
   h1 >>> span:nth-child(9) { /* s */
    grid-column: 7;
    grid-row: 8;
    animation-delay: 0s;
   }
  /* CINEMA */
  .cinema h1 >>> span:nth-child(1) { /* C */
      grid-column: 1;
      grid-row: 1;
      animation-delay: 0.5s;
    }
  .cinema h1 >>> span:nth-child(2) { /* i */
      grid-column: 2;
      grid-row: 2;
      animation-delay: 0.4s;
    }
  .cinema h1 >>> span:nth-child(3) { /* n */
      grid-column: 6;
      grid-row: 5;
      animation-delay: 0.3s;
    }
  .cinema h1 >>> span:nth-child(4) { /* e */
      grid-column: 7;
      grid-row: 5;
      animation-delay: 0.2s;
    }
  .cinema h1 >>> span:nth-child(5) { /* m */
      grid-column: 1;
      grid-row: 7;
      animation-delay: 0.1s;
    }
  .cinema h1 >>> span:nth-child(6) { /* a */
      grid-column: 6;
      grid-row: 8;
      animation-delay: 0s;
    }
  /* NOVAS MIDIAS */
    .midias h1 >>> span:nth-child(1) { /* N */
      grid-column: 3;
      grid-row: 2;
      animation-delay: 1s;
    }
    .midias h1 >>> span:nth-child(2) { /* o */
      grid-column: 4;
      grid-row: 2;
      animation-delay: 0.9s;
    }
    .midias h1 >>> span:nth-child(3) { /* v */
      grid-column: 6;
      grid-row: 3;
      animation-delay: 0.8s;
    }
    .midias h1 >>> span:nth-child(4) { /* a */
      grid-column: 4;
      grid-row: 4;
      animation-delay: 0.7s;
    }
    .midias h1 >>> span:nth-child(5) { /* s */
      grid-column: 5;
      grid-row: 4;
      animation-delay: 0.6s;
    }
    .midias h1 >>> span:nth-child(6) { /* M */
      grid-column: 8;
      grid-row: 5;
      animation-delay: 0.5s;
    }
    .midias h1 >>> span:nth-child(7) { /* í */
      grid-column: 1;
      grid-row: 6;
      animation-delay: 0.4s;
    }
    .midias h1 >>> span:nth-child(8) { /* d */
      grid-column: 2;
      grid-row: 6;
      animation-delay: 0.3s;
    }
    .midias h1 >>> span:nth-child(9) { /* i */
      grid-column: 4;
      grid-row: 7;
      animation-delay: 0.2s;
    }
    .midias h1 >>> span:nth-child(10) { /* a */
      grid-column: 6;
      grid-row: 7;
      animation-delay: 0.1s;
    }
    .midias h1 >>> span:nth-child(11) { /* s */
      grid-column: 5;
      grid-row: 8;
      animation-delay: 0s;
    }
  /* PRODUÇÃO CULTURAL */
    .producao h1 >>> span:nth-child(1) { /* P */
      grid-column: 6;
      grid-row: 1;
      animation-delay: 1.5s;
    }
    .producao h1 >>> span:nth-child(2) { /* r */
      grid-column: 7;
      grid-row: 1;
      animation-delay: 1.4s;
    }
    .producao h1 >>> span:nth-child(3) { /* o */
      grid-column: 8;
      grid-row: 1;
      animation-delay: 1.3s;
    }
    .producao h1 >>> span:nth-child(4) { /* d */
      grid-column: 3;
      grid-row: 2;
      animation-delay: 1.2s;
    }
    .producao h1 >>> span:nth-child(5) { /* u */
      grid-column: 5;
      grid-row: 3;
      animation-delay: 1.1s;
    }
    .producao h1 >>> span:nth-child(6) { /* ç */
      grid-column: 8;
      grid-row: 3;
      animation-delay: 1s;
    }
    .producao h1 >>> span:nth-child(7) { /* ã */
      grid-column: 1;
      grid-row: 4;
      animation-delay: 0.9s;
    }
    .producao h1 >>> span:nth-child(8) { /* o */
      grid-column: 2;
      grid-row: 4;
      animation-delay: 0.8s;
    }
    .producao h1 >>> span:nth-child(9) { /* C */
      grid-column: 6;
      grid-row: 4;
      animation-delay: 0.7s;
    }
    .producao h1 >>> span:nth-child(10) { /* u */
      grid-column: 4;
      grid-row: 5;
      animation-delay: 0.6s;
    }
    .producao h1 >>> span:nth-child(11) { /* l */
      grid-column: 5;
      grid-row: 5;
      animation-delay: 0.5s;
    }
    .producao h1 >>> span:nth-child(12) { /* t */
      grid-column: 6;
      grid-row: 6;
      animation-delay: 0.4s;
    }
    .producao h1 >>> span:nth-child(13) { /* u */
      grid-column: 2;
      grid-row: 7;
      animation-delay: 0.3s;
    }
    .producao h1 >>> span:nth-child(14) { /* r */
      grid-column: 8;
      grid-row: 7;
      animation-delay: 0.2s;
    }
    .producao h1 >>> span:nth-child(15) { /* a */
      grid-column: 5;
      grid-row: 8;
      animation-delay: 0.1s;
    }
    .producao h1 >>> span:nth-child(16) { /* l */
      grid-column: 6;
      grid-row: 8;
      animation-delay: 0s;
    }


@media (max-width: 768px) {
  .videosTela {display: none;}
}
</style>
